export default __webpack_public_path__ + "static/media/minusIcon.089a9fa1.svg";